import React from "react";
import { RichTextEditor } from "./RichTextEditor";
import { StoryNode } from "../StoryBook/StoryData";

export const RichTextEditorStories = [
    new StoryNode(
        () => {
            return <RichTextEditor />;
        },
        "Shared",
        "Rich Text Editor",
        "Default"
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ maxWidth: "500px" }}>
                    <RichTextEditor />
                </div>
            );
        },
        "Shared",
        "Rich Text Editor",
        "500px Wide"
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ maxWidth: "500px" }}>
                    <RichTextEditor hideTools={true} />
                </div>
            );
        },
        "Shared",
        "Rich Text Editor",
        "Hide Tools"
    ),

    new StoryNode(
        () => {
            return (
                <div style={{ maxWidth: "500px" }}>
                    <RichTextEditor
                        hideTools={true}
                        readOnly={true}
                    />
                </div>
            );
        },
        "Shared",
        "Rich Text Editor",
        "Readonly"
    ),
];
